<template>
  <div
    ref="hambugerV2"
    class="hambuger-v2"
    :class="[open ? 'hambuger-v2_display' : 'hambuger-v2_none']"
  >
    <div class="list">
      <div
        v-for="header in headerDataList"
        :key="header.key"
        class="list-chil"
        @click="handleRouter(header.name)"
      >
        <img :src="header.icon">
        <span class="text-list">{{ header.title }}</span>
      </div>
      <div class="divider" />
      <div
        v-for="item in staticScreenList"
        :key="item.key"
        class="other"
        @click="handleRouter(item.name)"
      >
        <img :src="item.icon">
        <span class="text-bottom">{{ item.title }}</span>
      </div>
    </div>
    <span class="footer-hambuger">Copyright (C) Gong cha Japan. All Rights Reserved.</span>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { headerData, staticScreen } from '@/assets/js/header.js'
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

export default {
  name: 'Hambuger',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const router = useRouter()
    const hambugerV2 = ref(null)
    const headerDataList = ref({ ...headerData})
    const staticScreenList = ref(staticScreen)

    const setCarItem = () => {
      if (!sessionStorage.getItem('cartItem')) {
        const infoCart = {
          listGood: [],
          bagMoney: null,
          payMethod: ''
        }
        sessionStorage.setItem('cartItem', JSON.stringify(infoCart))
      }
    }

    const handleRouter = (name) => {
      if (name === 'cart_v2' && !sessionStorage.getItem('storeId')) {
        ElMessage.closeAll()
        ElMessage.error('店舗を選んでください。')
        window.scrollTo(0, 0)
      } else if (
        name === 'cart_v2' && sessionStorage.getItem('storeId') &&
        (sessionStorage.getItem('isEatIn') == null || sessionStorage.getItem('isEatIn') == undefined)
      ) {
        ElMessage.closeAll()
        ElMessage.error('ご利用方法を選ぶんでください。')
        window.scrollTo(0, 0)
      } else if (name === 'add-shortcut') {
        handleCreateShortCut()
      } else {
        if (name === 'rank_v2') {
          let currentVersion = localStorage.getItem('version');
          router.push({ name: name, query: { v: currentVersion } })
        } else {
          router.push({ name: name })
        }
        emit('close')
        window.scrollTo(0, 0)
      }
    }

    const handleCreateShortCut = async () => {
      try {
        const url = 'https://miniapp.line.me/' + process.env.VUE_APP_LIFF_ID
        // eslint-disable-next-line no-undef
        await liff.createShortcutOnHomeScreen({
          url: url
        })
      } catch (error) {
        console.error(error.message)
      }
    }

    watch(
      () => props.open,
      (newVal) => {
        if (!newVal) {
          document.body.style.overflow = 'unset'
          setTimeout(() => {
            hambugerV2.value.style.display = 'none'
          }, 300)
        } else {
          setCarItem()
          hambugerV2.value.style.display = 'flex'
          document.body.style.overflow = 'hidden'
        }
      }
    )

    onMounted(() => {
      hambugerV2.value.style.display = 'none'
    })

    return {
      hambugerV2,
      headerDataList,
      staticScreenList,
      handleRouter,
      handleCreateShortCut,
      setCarItem
    }
  }
}
</script>

<style scoped></style>
